import { render } from "./new_user_certified_partner_serialnos.vue?vue&type=template&id=5695433e"
import script from "./new_user_certified_partner_serialnos.vue?vue&type=script&lang=js"
export * from "./new_user_certified_partner_serialnos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__